import { AUSN_THRESHOLD_60, PSN_THRESHOLD_60, USN_THRESHOLD_450 } from "./thresholds";
import { formatPhone, isValidDate, isValidEmail, isValidInn, isValidOgrn, isValidPhone, isValidUrl, } from "../../../utils";
import { RetailTaxationType } from "../../../api";
export const validateProfileProps = (values) => {
    return {
        ...values,
        user_reg_date: isValidDate(values.user_reg_date) ? values.user_reg_date : null,
        user_ogrn: isValidOgrn(values.user_ogrn) ? values.user_ogrn : null,
        user_inn: isValidInn(values.user_inn) ? values.user_inn : null,
        user_phone: isValidPhone(values.user_phone) ? formatPhone(values.user_phone) : null,
        user_mail: isValidEmail(values.user_mail) ? values.user_mail : null,
        user_site: isValidUrl(values.user_site) ? values.user_site : null,
        user_contact_mail: isValidEmail(values.user_contact_mail) ? values.user_contact_mail : null,
        user_contact_phone: isValidPhone(values.user_contact_phone) ? formatPhone(values.user_contact_phone) : null,
    };
};
export const validateRequestValues = (values, defaultParams) => {
    let result = { ...values };
    result = {
        ...validateProfileProps(result),
        swot: {
            opportunity_list: result.swot.opportunity_list?.filter(Boolean) ?? [],
            strength_list: result.swot.strength_list?.filter(Boolean) ?? [],
            threat_list: result.swot.threat_list?.filter(Boolean) ?? [],
            weakness_list: result.swot.weakness_list?.filter(Boolean) ?? [],
        },
        difference_list: result.difference_list?.filter(Boolean) ?? [],
        strategy_list: result.strategy_list?.filter(Boolean) ?? [],
        assortment1_list: result.assortment1_list?.filter(Boolean) ?? [],
        assortment2_list: result.assortment2_list?.filter(Boolean) ?? [],
        product_list: result.product_list?.reduce((acc, curr) => {
            return Boolean(curr.name) && Boolean(curr.price) ? [...acc, curr] : acc;
        }, []) ?? [],
        channel_list: result.channel_list?.filter(Boolean) ?? [],
        credit_bank: result.credit_bank === -1 ? null : result.credit_bank,
        credit_other: result.credit_bank !== -1 ? null : result.credit_other,
    };
    if (defaultParams !== undefined) {
        const totalRevenue = values.use_count * values.day_count * values.avg_check;
        const defaultTotalRevenue = defaultParams.use_count.value * defaultParams.day_count.value * defaultParams.avg_check.value;
        const isUsn = [RetailTaxationType.USN6, RetailTaxationType.USN15].includes(values.taxation);
        const isPsn = values.taxation === RetailTaxationType.PSN;
        const isAusn = [RetailTaxationType.AUSN8, RetailTaxationType.AUSN20].includes(values.taxation);
        if (isUsn && totalRevenue > USN_THRESHOLD_450) {
            result = {
                ...result,
                use_count: defaultParams.use_count.value,
                avg_check: defaultParams.avg_check.value,
                day_count: defaultParams.day_count.value,
            };
        }
        if (isPsn && totalRevenue > PSN_THRESHOLD_60) {
            result = {
                ...result,
                use_count: defaultParams.use_count.value,
                avg_check: defaultParams.avg_check.value,
                day_count: defaultTotalRevenue > PSN_THRESHOLD_60 ? 1 : defaultParams.day_count.value,
            };
        }
        if (isAusn && totalRevenue > AUSN_THRESHOLD_60) {
            result = {
                ...result,
                use_count: defaultParams.use_count.value,
                avg_check: defaultParams.avg_check.value,
                day_count: defaultTotalRevenue > AUSN_THRESHOLD_60 ? 1 : defaultParams.day_count.value,
            };
        }
    }
    return result;
};
